import { Divider, Typography } from 'antd'
import React, { Fragment } from 'react'
import { titles } from '../../setup/messages'

const DashboardPage: React.FC = () => {
  return (
    <Fragment>
      <Typography.Title level={2}>{titles.dashboard}</Typography.Title>
      <Divider />
      <p>Dashboard content</p>
    </Fragment>
  )
}
export default DashboardPage
